<ng-container *translateBlock="let t">
  <p-stepper [(value)]="currentStep"
             [linear]="false">

    <app-stepper-component [activeStep]="currentStep"
                           [steps]="createStepper"
                           (onStepClickEvent)="goToStep($event)" />

    <p-step-panels>
      <p-step-panel [value]="ReportSteps.SELECT_REPORT_TYPE">
        <ng-template #content>
          <app-report-type [reportForm]="reportForm"
                           (nextClick)="nextStep(currentStep)" />
        </ng-template>
      </p-step-panel>


      <p-step-panel [value]="ReportSteps.SELECT_TIME">
        <ng-template #content>
          <app-date-range [reportForm]="reportForm" />
        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="ReportSteps.SELECT_ELEMENTS">
        <ng-template #content>
          @if (reportType() === ReportType.DEVICE_DETAIL) {
            <app-report-select-device [formGroup]="deviceSelectForm" />
          }
        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="ReportSteps.FILTER_ELEMENTS">
        <ng-template #content>
          @if (reportType() === ReportType.DEVICE) {
            <app-report-filter-device [formGroup]="deviceFilterForm" />
          }

          @if (reportType() === ReportType.ALARM) {
            <app-report-filter-alarm [formGroup]="alarmFilterForm" />
          }

          @if (reportType() === ReportType.LOG) {
            <app-report-filter-log [formGroup]="logFilterForm" />
          }

          @if (reportType() === ReportType.MEASUREMENT) {
            <app-report-measurement (reportOptionsChange)="onMeasurementReportOptionsChange($event)" />
          }
        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="ReportSteps.SELECT_COLUMNS">
        <ng-template #content>
          @if (reportType() === ReportType.ALARM) {
            <app-report-column-step [formGroup]="columnStepAlarm.getForm()"
                                    [column]="columnStepAlarm.column" />
          }
          @if (reportType() === ReportType.DEVICE) {
            <app-report-column-step [formGroup]="columnStepDevice.getForm()"
                                    [column]="columnStepDevice.column" />
          }
          @if (reportType() === ReportType.LOG) {
            <app-report-column-step [formGroup]="columnStepLog.getForm()"
                                    [column]="columnStepLog.column" />
          }

        </ng-template>
      </p-step-panel>
      <p-step-panel [value]="ReportSteps.SELECT_FORMAT">
        <ng-template #content>

          <app-report-format [formGroup]="reportForm" />

        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="ReportSteps.DOWNLOAD_REPORT">
        <ng-template #content>

          @if (reportType() === ReportType.SIGI) {
            <app-sigi-files />
          } @else {
            <app-report-download [formGroup]="reportForm" />
          }

        </ng-template>

      </p-step-panel>

      @if (currentStep !== ReportSteps.SELECT_REPORT_TYPE) {
        <div class="step-actions between">
          <app-button-icon
            [label]="t('common.actions.back')"
            iconName="arrow_back"
            class="iconless"
            (click)="goBack(currentStep)" />


          @if (reportType() === ReportType.SIGI) {

          } @else if (currentStep === ReportSteps.DOWNLOAD_REPORT) {
            <app-button-icon
              [label]="t('common.actions.generate')"
              iconName="file_save"
              class="iconless"
              [disabled]="loading"
              (click)="doGenerate()" />
          } @else {
            <app-button-icon
              [label]="t('common.actions.next')"
              iconName="arrow_forward"
              class="iconless"
              [disabled]="!canContinue(currentStep)"
              (click)="nextStep(currentStep)" />
          }
        </div>
      }
    </p-step-panels>
  </p-stepper>
</ng-container>
